import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M1 11.6V16h8.31l-1.12 5.38L9.83 23 17 15.82V3H4.69zM19 3h4v12h-4z"
}), 'ThumbDownAltSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ThumbDownAltSharp.js
// module id = 6778
// module chunks = 2